import { useState, useEffect } from "react";
import { getBookingList } from "../../services/appointment.service";
import moment from "moment";
import { useNavigate } from "react-router-dom";

function TvScreen() {
  const navigate = useNavigate();
  const [showSkelton, setShowSkelton] = useState(false);
  const [list, setList] = useState([]);
  const [flattenedList, setFlattendList] = useState([]);
  const handleGetBookingList = async () => {
    setShowSkelton(true);
    try {
      let response = await getBookingList({ status: "kundaliAdded" });
      if (response?.data?.success) {
        setList(response?.data?.data);
        // Combine all kundaliDetails into a single array
        const flattenedList = response?.data?.data?.flatMap((value) =>
          value?.kundaliDetails?.map((v) => ({
            ...value,
            kundaliDetails: v, // Attach individual kundaliDetails to the parent object
          }))
        );
        let filteredArr = flattenedList?.filter((v, i)=>{
          return v?.tokenNo == flattenedList[0].tokenNo
        })
        setFlattendList(filteredArr);
      }
    } catch (error) {
      console.log(error);
    }
    setShowSkelton(false);
  };
  useEffect(() => {
    handleGetBookingList(); // Call immediately when screen loads
    const interval = setInterval(() => {
        handleGetBookingList();
    }, 5000); // Call every 5 seconds

    return () => clearInterval(interval); // Cleanup on unmount
}, []);
  return (
    <>
      <div className="user-details-container" style={{ minHeight: "100vh", height: "100%" }}>
        <div
          className="container d-flex align-items-center justify-content-between py-4"
          style={{
            padding: "20px 30px",
            color: "#E1C699",
          }}
        >
          {/* Logo Section */}
          <div className="d-flex flex-column">
            <img src="/images/brandLogo.png" className="brandLogo img-fluid" />
          </div>

          {/* Title */}
          <div className="text-center" style={{ fontSize: "3rem", fontWeight: "bold", color: "#C6A664" }}>
            USER DETAILS
          </div>

          {/* Date and Time */}
          <div className="text-end">
            <p style={{ margin: 0, fontSize: "1.8rem", fontWeight: "500" }}>{moment().format("Do MMM YYYY")}</p>
            <p style={{ margin: 0, fontSize: "1.8rem", fontWeight: "500" }}> {moment().format("hh:mm A")}</p>
          </div>
        </div>

        <div className="container my-4 p-4 border border-white user-card-data">
          <table className="table ">
            <thead>
              <tr style={{ background: "rgba(0, 0, 0, 0.3)", color: "#fff", padding: "20px" }}>
                <th scope="col" style={{ borderRadius: "24px 0px 0px 24px" }}>
                  <div className="d-flex justify-content-center ms-2">
                    <span className="mx-2">Token Number</span>
                  </div>
                </th>

                <th scope="col">Full Name</th>
                <th scope="col">Number of Kundali</th>

                <th scope="col" style={{ borderRadius: "0px 24px 24px 0px" }}>
                  Time
                </th>
              </tr>
            </thead>

            <div className="pt-3 pb-2 "></div>
            <tbody className="">
              {list?.map((v, i) => {
                return (
                  <>
                    <tr
                      key={i}
                      style={{
                        background: i === 0 ? "#D1B085" : "rgba(0, 0, 0, 0.1)",
                        cursor: "pointer",
                        border: "2px solid red",
                      }}
                      
                    >
                      <td scope="row" style={{ borderRadius: "12px 0px 0px 12px", color: i === 0 ? "#000" : "#fff" }}>
                        {v?.tokenNo}
                      </td>

                      <td style={{ color: i === 0 ? "#000" : "#fff" }}>{v?.fullName} </td>
                      <td style={{ color: i === 0 ? "#000" : "#fff" }}>{v?.kundaliDetails?.length} </td>

                      <td style={{ color: i === 0 ? "#000" : "#fff", borderRadius: "0px 24px 24px 0px" }}>
                        {v?.scheduledTime}
                      </td>
                    </tr>
                    <div className="py-2"></div>
                  </>
                );
              })}
            </tbody>
          </table>
          {list?.length == 0 && !showSkelton && (
            <div
              className="noRecordFoundMain d-flex justify-content-center align-items-center bg-dark"
              style={{ height: "55vh" }}
            >
              <div className="noRecordFoundInner text-light p-5  bg-dark">
                <h1>"This page is currently empty."</h1>
                <p>
                  "It seems like there's no data to display here yet. As you manage and grow, this space will soon be
                  filled with valuable information."
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default TvScreen;
